import { inject, Injectable, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Cuisine, getClient } from '@monorepo-channels/channels/domain'
import { Store } from '@ngrx/store'
import { tap } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class FilterState {
	public excludeBenefitIds = [{ _id: 0, display: 'Sem Desconto', name: 'desconto' }]

	private store = inject(Store)

	public benefitIds: { _id: number; display: string; name: string }[] = []

	public searchChange = signal('')
	public selectedCategory = signal<Array<string>>([])
	public selectedBenefitIds = signal<typeof this.benefitIds>([])
	public selectedExcludeBenefitIds = signal<typeof this.excludeBenefitIds>([])
	public selectedCuisine = signal<Array<Cuisine>>([])
	public count = signal(0)

	constructor() {
		this.store
			.select(getClient)
			.pipe(
				tap(() => {
					this.benefitIds = [
						{ _id: 0, display: 'Desconto', name: 'desconto' },
						{ _id: 1, display: 'Sobremesa', name: 'sobremesa' },
						{ _id: 2, display: 'Sobremesa Visa', name: 'sobremesa visa' },
						{ _id: 3, display: 'Entrada', name: 'entrada' },
						{ _id: 4, display: 'Entrada Visa', name: 'entrada visa' },
						{ _id: 5, display: 'Drink', name: 'drink' },
						{ _id: 6, display: 'Drink Visa', name: 'drink Visa' },
					]
				}),
				takeUntilDestroyed()
			)
			.subscribe()
	}

	setCategory(category: string) {
		// Toggle category in selectedCategory array
		this.selectedCategory.set(
			this.selectedCategory().includes(category)
				? this.selectedCategory().filter(c => c !== category)
				: [...this.selectedCategory(), category]
		)
	}

	setBenefit(benefitIds: (typeof this.benefitIds)[0]) {
		console.log(benefitIds)
		this.selectedBenefitIds.set(
			this.includesBenefit(benefitIds)
				? this.selectedBenefitIds().filter(c => c._id !== benefitIds._id)
				: [...this.selectedBenefitIds(), benefitIds]
		)
	}

	setCuisine(cuisine: Cuisine) {
		// Toggle cuisine in selectedCuisine array
		this.selectedCuisine.set(
			this.includesCuisine(cuisine)
				? this.selectedCuisine().filter(c => c._id !== cuisine._id)
				: [...this.selectedCuisine(), cuisine]
		)
	}

	includesCategory(category: string) {
		return this.selectedCategory().includes(category)
	}

	includesCuisine(cuisine: Cuisine) {
		return this.selectedCuisine().some(c => c._id === cuisine._id)
	}

	includesBenefit(benefitIds: (typeof this.benefitIds)[0]) {
		return this.selectedBenefitIds().some(c => c._id === benefitIds._id)
	}

	setExcludeBenefitIds(excludeBenefitIds: (typeof this.excludeBenefitIds)[0]) {
		this.selectedExcludeBenefitIds.set(
			this.includesExcludeBenefit(excludeBenefitIds)
				? this.selectedExcludeBenefitIds().filter(c => c._id !== excludeBenefitIds._id)
				: [...this.selectedExcludeBenefitIds(), excludeBenefitIds]
		)
	}

	includesExcludeBenefit(excludeBenefitIds: (typeof this.excludeBenefitIds)[0]) {
		return this.selectedExcludeBenefitIds().some(c => c._id === excludeBenefitIds._id)
	}

	resetState() {
		this.selectedCategory.set([])
		this.selectedCuisine.set([])
		this.selectedBenefitIds.set([])
		this.selectedExcludeBenefitIds.set([])
	}

	assignCount() {
		let count = 0
		if (this.selectedCategory().length !== 0) count += this.selectedCategory().length
		if (this.selectedCuisine().length !== 0) count += this.selectedCuisine().length
		if (this.selectedBenefitIds().length !== 0) count += this.selectedBenefitIds().length
		if (this.selectedExcludeBenefitIds().length !== 0) count += this.selectedExcludeBenefitIds().length
		this.count.set(count)
	}
}
